// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const InputContract = contract({
  name: "Input",
  description: "Any single-line text entry. Always pair with a Label for accessibility. Use startSlot/endSlot for icons, prefixes and units instead of hand-positioning absolute children; use size=\"sm\"/\"xs\" in dense tool panels.",
  import: "@gradeui/ui",
  aliases: ["text field","textbox","textfield","form field","text input","secure field","search field","url field","number field","textinput","text input field","react native textinput","unit input","input with icon"],
  element: "input",
  composesWith: ["Label","Form","Card (in CardContent)","Button (form submit)"],
  styleDefaults: {"Input":"flex w-full rounded-md bg-transparent transition-colors file:border-0 file:bg-transparent file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50"},
  variantDefaults: {"size":"default","variant":"default"},
  props: {
  "type": {
      schema: z.string().optional(),
      design: "content",
  },
  "placeholder": {
      schema: z.string().optional(),
      design: "content",
      description: "hint text shown while the input is empty. Model it explicitly (not just a native passthrough) so generated screens carry placeholders and the validator accepts them.",
  },
  "size": {
      schema: z.enum(["lg", "default", "sm", "xs", "2xs"]).optional(),
      design: "knob",
      description: "control density. `lg` (h-11, stays 16px text) for a prominent single-value field like an amount in a dialog; `default` (h-9) for forms; `sm` (h-8), `xs` (h-7) and `2xs` (h-6) for dense tool panels like the inspector. NOTE: pre-unification scale — see Figma parity audit; due to migrate to the t-shirt scale (xs 24 | sm 28 | md 32 | lg 40, default→md).",
  },
  "startSlot": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "adornment rendered inside the leading edge (icon, prefix, currency symbol). Non-interactive by default so clicks focus the input.",
  },
  "endSlot": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "adornment rendered inside the trailing edge (unit like \"px\", a clear button, a stepper). Same pointer rules as startSlot.",
  },
  "revealable": {
      schema: z.boolean().optional(),
      design: "knob",
      description: "adds the show/hide eye toggle to a `type=\"password\"` field, with the aria-label and aria-pressed wiring done. Ignored on any other type. THIS is the password field: do not hand-compose an eye button into endSlot, and do not reach for a separate PasswordInput, there isn't one. Composes with endSlot (the consumer's adornment renders first, the toggle sits outermost).",
  },
  },
});
